export const DBOO = '/data-broker-removal';

export const DBOO_SCANNING = `${DBOO}/scanning`;
export const DBOO_RE_SCANNING = `${DBOO}/re-scanning`;
export const DBOO_NO_RESULTS = `${DBOO}/no-results`;
export const DBOO_RESULTS = `${DBOO}/results`;
export const DBOO_FINISH = `${DBOO}/finish`;
export const DBOO_NARROW_RESULTS = `${DBOO}/narrow-results`;
export const DBOO_YEAR_OF_BIRTH = `${DBOO}/year-of-birth`;
export const DBOO_BROKER_LIST = `${DBOO}/broker-list`;

// Optout flow
export const DBOO_REQUEST_OPTOUT = `${DBOO}/request-optout`;
export const DBOO_REQUEST_OPTOUT_NEED_MORE_INFO = `${DBOO_REQUEST_OPTOUT}/need-more-info`;
export const DBOO_REQUEST_OPTOUT_START_OPTOUT = `${DBOO_REQUEST_OPTOUT}/opt-out`;

// Education Flow
export const DBOO_EDUCATION = `${DBOO}/education`;
export const DBOO_EDUCATION_START_FLOW = `${DBOO_EDUCATION}/1`;
export const DBOO_EDUCATION_END_FLOW = `${DBOO_EDUCATION}/5`;
